(function () {
  'use strict';

  var CART_ID = '693ff4f65530dbb1c61825d9';
  var RULES = {
    PL: ['PLN', 439], SE: ['SEK', 1129], DK: ['DKK', 749],
    CZ: ['CZK', 2429], HU: ['HUF', 36259], RO: ['RON', 529],
    GB: ['GBP', 89], CH: ['CHF', 99], LI: ['CHF', 99], NO: ['NOK', 1089]
  };
  var EUR_COUNTRIES = 'AT BE BG HR EE FI FR DE GR IE IT LV LT LU NL PT SK SI ES CY MT'.split(' ');

  function resolveRule(country, currency) {
    var rule = RULES[country];
    if (!rule && EUR_COUNTRIES.indexOf(country) !== -1) rule = ['EUR', 99];
    if (!rule) return { supported: false };
    return { supported: true, matches: currency === rule[0], currency: rule[0], amount: rule[1] };
  }

  function isObject(value) {
    return value !== null && (typeof value === 'object' || typeof value === 'function');
  }

  function install(target, initialContext) {
    var guardedRoots = new WeakSet();
    var guardedConfigs = new WeakSet();

    function context() {
      var shopify = target.Shopify || {};
      return {
        country: String(shopify.country || initialContext.country || '').toUpperCase(),
        currency: String((shopify.currency || {}).active || initialContext.currency || '').toUpperCase()
      };
    }

    function normalize(config) {
      if (!isObject(config) || config.id !== CART_ID) return config;
      var rewards = config.rewardsProgressBar;
      if (!isObject(rewards) || rewards.rewardBasic !== 'Cart total') return config;
      var tiers = rewards.tierSettings;
      // This integration is scoped to the existing single shipping tier.
      // Never change the conversion or eligibility of gifts/discount tiers.
      if (!Array.isArray(tiers) || tiers.length !== 1 || tiers[0].rewardType !== 'Shipping') return config;
      var current = context();
      var rule = resolveRule(current.country, current.currency);
      // A mismatched currency cannot accurately promise a local shipping rate.
      if (rule.supported && !rule.matches) {
        rewards.isCheck = false;
        target.__pbSnapShippingStatus = { country: current.country, currency: current.currency, applied: false, reason: 'currency-mismatch' };
        return config;
      }
      // C7 review: Snap's own translations still carry a stale 159 threshold, so a country without a
      // verified rule shows no bar rather than a wrong amount.
      if (!rule.supported) {
        rewards.isCheck = false;
        target.__pbSnapShippingStatus = { country: current.country, currency: current.currency, applied: false, reason: 'unsupported-country' };
        return config;
      }
      rewards.isCheck = true;
      rewards.showAnimation = true;
      rewards.isConvertCurrency = false;
      rewards.isSetDifferentPrice = false;
      tiers[0].minimumAmount = String(rule.amount);
      tiers[0].differentMarketMinAmount = '';
      var translations = config.autoTranslations && config.autoTranslations.translatedMessage;
      if (Array.isArray(translations)) {
        translations.forEach(function (language) {
          var translatedTiers = language.rewardsProgressBar && language.rewardsProgressBar.tierSettings;
          if (Array.isArray(translatedTiers) && translatedTiers.length === 1 && translatedTiers[0].rewardType === 'Shipping') {
            translatedTiers[0].minimumAmount = String(rule.amount);
            translatedTiers[0].differentMarketMinAmount = '';
            // The existing Dutch shipping tier contains English gift copy.
            // Correct only those known defaults; preserve later merchant edits.
            if (language.locale === 'nl') {
              if (language.rewardsProgressBar.rewardFull === 'Congratulations! You have achieved Free gift(s)') {
                language.rewardsProgressBar.rewardFull = 'Je hebt gratis verzending ontgrendeld.';
              }
              if (translatedTiers[0].rewardDescription === 'Free shipping') {
                translatedTiers[0].rewardDescription = 'Gratis verzending';
              }
              if (translatedTiers[0].textBeforeCompletingTier === 'You are {{min_amount}} away from Free shipping') {
                translatedTiers[0].textBeforeCompletingTier = 'Nog {{min_amount}} tot gratis verzending.';
              }
            }
          }
        });
      }
      target.__pbSnapShippingStatus = { country: current.country, currency: current.currency, amount: rule.amount, applied: true };
      return config;
    }

    function guardConfig(config) {
      if (!isObject(config) || config.id !== CART_ID) return config;
      normalize(config);
      if (guardedConfigs.has(config)) return config;
      guardedConfigs.add(config);
      // The app owns these objects. Keep their identity, and do not replace
      // native accessors or non-configurable properties.
      ['rewardsProgressBar', 'autoTranslations'].forEach(function (key) {
        var descriptor = Object.getOwnPropertyDescriptor(config, key);
        if (descriptor && (descriptor.get || descriptor.set || !descriptor.configurable)) return;
        var value = config[key];
        Object.defineProperty(config, key, {
          configurable: true,
          enumerable: descriptor ? descriptor.enumerable : true,
          get: function () { return value; },
          set: function (next) { value = next; normalize(config); }
        });
      });
      return config;
    }

    function guardRoot(root) {
      if (!isObject(root)) return root;
      guardConfig(root.cartConfig);
      if (guardedRoots.has(root)) return root;
      guardedRoots.add(root);
      var descriptor = Object.getOwnPropertyDescriptor(root, 'cartConfig');
      if (descriptor && (descriptor.get || descriptor.set || !descriptor.configurable)) return root;
      var currentConfig = root.cartConfig;
      Object.defineProperty(root, 'cartConfig', {
        configurable: true,
        enumerable: descriptor ? descriptor.enumerable : true,
        get: function () { return normalize(currentConfig); },
        set: function (next) { currentConfig = guardConfig(next); }
      });
      return root;
    }

    function guardGlobal(global) {
      if (!isObject(global)) return;
      var descriptor = Object.getOwnPropertyDescriptor(global, 'snapCart');
      if (descriptor && (descriptor.get || descriptor.set || !descriptor.configurable)) {
        guardRoot(global.snapCart);
        return;
      }
      var currentRoot = guardRoot(global.snapCart);
      Object.defineProperty(global, 'snapCart', {
        configurable: true,
        enumerable: descriptor ? descriptor.enumerable : true,
        get: function () { return currentRoot; },
        set: function (next) { currentRoot = guardRoot(next); }
      });
    }

    guardGlobal(target);
    if (target.Window && target.Window !== target) guardGlobal(target.Window);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { resolveRule: resolveRule, install: install };
  } else if (typeof window !== 'undefined') {
    var element = document.getElementById('pb-snap-shipping-context');
    if (!element) return;
    try { install(window, JSON.parse(element.textContent)); }
    catch (error) {
      window.__pbSnapShippingStatus = { applied: false, reason: 'unsupported-config' };
    }
  }
}());
